import React from "react";
import { Button } from "antd";
import { FilePdfOutlined } from "@ant-design/icons";

export default function familyGroupColumns(onOpenModal, openReportOptions) {
  return [
    {
      title: "Group Name",
      dataIndex: "group_name",
      key: "group_name",
      ellipsis: false,
      render: (text, record) => (
        <a onClick={() => onOpenModal(record)}>{text}</a>
      ),
    },
    {
      title: "Master PAN",
      dataIndex: "master_pan",
      key: "master_pan",
      ellipsis: false,
      render: (text, record) => (
        <a onClick={() => onOpenModal(record)}>{text}</a>
      ),
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      key: "mobile",
      ellipsis: false,
      responsive: ["md"],
      render: (val) =>
        val !== null && val !== undefined && val !== "" ? val : "-",
    },
    {
      title: "Total Investment",
      responsive: ["sm"],
      dataIndex: ["totals", "total_investment"],
      key: "total_investment",
      align: "right",
      ellipsis: false,
      responsive: ["md"],
      render: (val) =>
        val !== null && val !== undefined
          ? `₹${Number(val).toLocaleString()}`
          : "-",
    },
    {
      title: "Redemption / Switches",
      responsive: ["sm"],
      children: [
        {
          title: "Cost Amount",
          dataIndex: ["totals", "redemption_cost_amount"],
          key: "redemption_cost_amount",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
        {
          title: "Actual Amount",
          dataIndex: ["totals", "redemption_actual_amount"],
          key: "redemption_actual_amount",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
      ],
    },
    {
      title: "Remaining Value",
      children: [
        {
          title: "Cost Amount",
          dataIndex: ["totals", "remaining_cost_value"],
          key: "remaining_cost_value",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
        {
          title: "Current Value",
          dataIndex: ["totals", "current_value"],
          key: "current_value",
          align: "right",
          ellipsis: false,
          render: (val) =>
            val !== null && val !== undefined
              ? `₹${Number(val).toLocaleString()}`
              : "-",
        },
      ],
    },
    // ✅ New XIRR column
    {
      title: "XIRR (%)",
      responsive: ["sm"],
      dataIndex: ["totals", "xirr"],
      key: "xirr",
      align: "right",
      ellipsis: false,
      render: (val) => {
        if (val === null || val === undefined) return "-";
        const color = val > 0 ? "green" : "red";
        return <span style={{ color }}>{Number(val).toFixed(2)}</span>;
      },
    },
    // ✅ New Absolute Return column
    {
      title: "Abs.Ret(%)",
      responsive: ["sm"],
      dataIndex: ["totals", "absolute"],
      key: "absolute",
      align: "right",
      ellipsis: false,
      render: (val) => {
        if (val === null || val === undefined) return "-";
        const color = val > 0 ? "green" : "red";
        return <span style={{ color }}>{Number(val).toFixed(2)}</span>;
      },
    },
    {
      title: "PDF",
      key: "pdf",
      width: 60,
      align: "center",
      render: (_, record) => (
        <Button
          type="text"
          title="Build Family Portfolio Report"
          icon={<FilePdfOutlined style={{ fontSize: 21, color: "#d32f2f" }} />}
          onClick={(e) => {
            e.stopPropagation();
            openReportOptions(record);
          }}
        />
      ),
    },
  ];
}
